export default __webpack_public_path__ + "static/media/Titel.4ff92b0e.png";